import { useState, useCallback } from 'react'
import segmentQuickAddToBagClicked from 'components/shared/quick-add-to-bag-modal/quick-add-to-bag-segment/quickAddToBagSegment'

const useAddDiamondToCart = ({
  refType,
  addToCart,
  updateCart,
  id_product,
  id_product_attribute,
  applyStoreCredit,
}) => {
  const [isAddingCart, setIsAddingCart] = useState(false)

  const handleClickAddToCart = useCallback(async () => {
    try {
      setIsAddingCart(true)
      await addToCart({
        quantity: 1,
        type: 'AddToCart',
        ignoreCache: true,
        productID: id_product,
        productAttributeID: id_product_attribute,
        body: {
          is_store_credits_applied: applyStoreCredit,
        },
      })
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
    } finally {
      setIsAddingCart(false)
      await updateCart({
        cartOpen: true,
      })
      segmentQuickAddToBagClicked({
        id_product,
        ref_type: refType,
      })
    }
  }, [
    refType,
    addToCart,
    updateCart,
    applyStoreCredit,
    id_product_attribute,
    id_product,
  ])

  return {
    handleClickAddToCart,
    isAddingCart,
  }
}

export default useAddDiamondToCart
